import { styled, css } from '@vebox/etui-system';
import { createElement, Fragment } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, A, Span } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';

const _excluded = ["theme"];
const TabDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    outline: 0,
    height: theme.shape.tabsHeight,
    p: 0,
    margin: 0,
    whiteSpace: 'nowrap'
  }, props);
})``;

const _excluded$1 = ["isActive", "isDisabled", "theme"];
const TabA = styled(A).attrs(_ref => {
  let {
      isActive,
      isDisabled,
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2(_objectSpread2({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  }, theme.typography.button), {}, {
    m: 0,
    p: `0 ${theme.spacing.md}px`,
    height: theme.shape.tabsHeight,
    color: theme.palette.text.secondary,
    ariaSelected: isActive,
    ariaDisabled: isDisabled,
    userSelect: 'none'
  }, rest);
})`
  cursor: pointer;
  text-decoration: none;
  transition: 0.2s;

  &:hover {
    ${({
  isDisabled
}) => !isDisabled && css`
        filter: brightness(0.7);
        cursor: pointer;
      `}
  }

  ${({
  isActive,
  isDisabled,
  theme
}) => {
  if (isDisabled) {
    return css`
        cursor: not-allowed;
        color: ${theme.palette.text.disabled};
      `;
  }
  if (isActive) {
    return css`
        color: ${theme.palette.text.primary};

        :after {
          border-bottom: 2px solid ${theme.palette.text.primary};
          bottom: 0;
          content: '';
          left: 0;
          position: absolute;
          right: 0;
        }
      `;
  }
  return ``;
}};
`;

const _excluded$2 = ["isActive", "bg", "theme", "hasText"];
const TabIconDiv = styled(Div).attrs(_ref => {
  let {
      isActive,
      bg: color,
      theme,
      hasText
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  return _objectSpread2({
    color: isActive ? color || theme.palette.primary.main : color || theme.palette.text.secondary,
    mr: `${hasText ? theme.spacing.xs : 0}px`
  }, rest);
})`
  display: flex;
  position: relative;
`;

const TabSpan = styled(Span)`
  letter-spacing: ${({
  theme
}) => theme.typography.button.letterSpacing};
`;

const Tab = ({
  tab,
  isActive,
  disabled,
  icon,
  value,
  onChange,
  onRender,
  props = {},
  styles = {}
}) => {
  const handleOnClick = event => {
    event.preventDefault();
    onChange(value);
  };
  const tabAProps = _objectSpread2({}, props.a);
  return /*#__PURE__*/createElement(TabDiv, _extends({}, props.root, styles.root), /*#__PURE__*/createElement(TabA, _extends({}, tabAProps, {
    isActive: isActive,
    onClick: disabled ? null : handleOnClick,
    isDisabled: disabled
  }, styles.a), onRender ? onRender() : /*#__PURE__*/createElement(Fragment, null, icon && /*#__PURE__*/createElement(TabIconDiv, _extends({
    isActive: isActive,
    hasText: !!tab
  }, styles.iconContainer), /*#__PURE__*/createElement(Icon, _extends({
    size: 32,
    glyph: icon
  }, props.icon))), /*#__PURE__*/createElement(TabSpan, null, tab))));
};

export default Tab;
